import React, { useEffect } from 'react';
import { Header } from '../Header';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Footer } from '../Footer';
import { useSelector, useDispatch } from 'react-redux';
import { fetchProfile } from '../../store/slices/profileSlice';

import { BottomNavigation } from '../BottomNavigation';

import { VideoUploadProvider } from '../../context/VideoUploadContext';
import { BackgroundUploadWidget } from '../BackgroundUploadWidget';

export const Layout = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isHomepage = pathname === '/';
    const isVideoFeed = pathname === '/video-feed';

    const { isAuthenticated } = useSelector((state) => state.auth);
    const { profile, loading, fetched, error } = useSelector((state) => state.profile);

    useEffect(() => {
        document.body.classList.toggle('homepage', isHomepage);
        return () => document.body.classList.remove('homepage');
    }, [isHomepage]);

    // Load profile if authenticated and not loaded yet
    useEffect(() => {
        if (isAuthenticated && !profile && !loading.profile && !fetched && !error.profile) {
            dispatch(fetchProfile());
        }
    }, [isAuthenticated, profile, loading.profile, fetched, error.profile, dispatch]);

    // Global guard: Redirect to onboarding if not completed
    useEffect(() => {
        if (isAuthenticated && profile) {
            const hasLanguages = profile.languages && profile.languages.length > 0;
            const needsScreening = profile.user_type === 'teacher' && (profile.isQuestionComplete === false || profile.screening_status === 'rejected');
            const isPendingScreening = profile.user_type === 'teacher' && profile.screening_status === 'pending';

            if (needsScreening || !hasLanguages || isPendingScreening) {
                navigate('/onboarding');
            }
        }
    }, [isAuthenticated, profile, navigate]);

    return (
        <VideoUploadProvider>
            {/* Common Menubar Component */}
            <Header />

            <div className="main-content-wrapper position-relative">
                <Outlet />
            </div>

            {!isVideoFeed && <Footer />}

            {/* Global Background Upload Progress Widget */}
            <BackgroundUploadWidget />
        </VideoUploadProvider>
    );
};
